<template>
  <div v-if="allCategories.length > 0" class="is-relative pb-5">
    <h4 class="fw-700 mb-5 uppercase">
      {{ $t('verifyProfile.categories.label') }}
    </h4>
    <ion-item class="mb-5">
      <ion-checkbox
        v-model="currentNoCategories"
        :model-value="noCategories"
        color="primary"
        slot="start"
        label-placement="end"
        >{{ $t('verifyProfile.noCategory') }}
      </ion-checkbox>
    </ion-item>

    <AppSelect
      v-model="selectedCategories"
      :multiple="true"
      class="user-profession-select ion-margin-bottom"
      :placeholder="$t('verifyProfile.categories.placeholder')"
      :disabled="currentNoCategories"
      expanded
      :items="allCategories"
    />
  </div>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';
import { useStore } from 'vuex';
import AppSelect from '@/components/common/AppSelect';
import { IonItem, IonCheckbox, IonLabel } from '@ionic/vue';

const props = defineProps({
  userCategories: {
    type: Array,
    default: () => [],
  },
  professions: {
    type: Array,
    default: () => [],
  },
  noCategories: {
    type: [Boolean, Number],
    default: false,
  },
});

const store = useStore();

const selectedCategories = ref([]);
const allCategories = ref([]);
const currentNoCategories = ref(false);

watch(
  () => props.userCategories,
  (newVal) => {
    selectedCategories.value = newVal.map((item) => item.id);
  },
  { immediate: true },
);

watch(
  selectedCategories,
  (newVal) => {
    if (!newVal) return;
    store.dispatch('profile/updateUserCategories', newVal);
  },
  { immediate: true },
);

watch(
  () => props.professions,
  (newValue) => {
    store
      .dispatch(
        'profile/fetchCategoriesByProfessionId',
        newValue.map((p) => p.profession_id),
      )
      .then((response) => {
        allCategories.value = response
          ?.filter((c) => c.is_active)
          .map((c) => ({
            id: c.id,
            name: c.name,
          }));
      });
  },
  { immediate: true },
);

watch(
  () => props.noCategories,
  (newVal) => {
    currentNoCategories.value = !!newVal;
  },
  { immediate: true },
);

watch(
  () => currentNoCategories.value,
  (newVal) => {
    if (newVal) {
      selectedCategories.value = [];
      store.dispatch('profile/setNoCategories', []);
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
ion-checkbox::part(container) {
  border: 2px solid var(--ion-color-primary);
  border-radius: 2px;
}
</style>
